import React, { Component } from "react";
import TextInput from "../../../controls/TextInput";

const RedTextInput = ({ hasError, value, onChange, onKeyPress, onFocus, onBlur, id, style, disabled }) => {
    const className = hasError ? "picker-hollow has-error" : "picker-hollow";
    return (
        <TextInput inputClassName={className} id={id}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onBlur={onBlur}
            onFocus={onFocus}
            tabIndex={0}
            value={value}
            style={style}
            disabled = {disabled}
        />
    );
};

export default RedTextInput;
